import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

import cl from './Contacts.module.css';

const Contacts = (props) => {
  const position = props.coordinates?.split(', ') || [41.911519, 12.503961];

  return (
    <section className={cl.contact}>
      <img
        className={cl.big_image}
        src="https://www.iai.co.il/drupal/sites/default/files/2022-02/Contact%20us.jpg"
      />
      <div className={cl.main}>
        <div>
          <p>Se avete domande o dubbi, non esitate a contattarci.</p>
          <p>Ci piacerebbe sentire la tua opinione, contattaci a:</p>
          <div className={cl.contacts}>
            <p>
              Email:{' '}
              <a href={'mailto: supporto@' + props.domain}>
                supporto@{props.domain}
              </a>
            </p>
            <p>{props.shopName} Gruppo di negozi</p>
            <p>{props.address}</p>
            <p>
              Tel: <a href="tel:+392362588879">+392362588879</a>
            </p>
          </div>
        </div>
        <div>
          <MapContainer
            center={position}
            zoom={15}
            scrollWheelZoom={false}
            style={{ height: '450px', width: '700px', margin: '1rem auto' }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position} />
          </MapContainer>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
